// Request util for api call
import request from '~/utils/request';

// Actions Types
import { SET_EXPORT_LOGS_LOADER, SET_EXPORT_LOGS_DATA } from './action-types';
import { DEFAULT_PAGINATION } from '~/utils/constants';
import { dateFormat } from '~/utils/date-format';

const fetchExportLogs = (payload) => async (dispatch) => {
  try {
    dispatch({ type: SET_EXPORT_LOGS_LOADER, payload: true });

    let url = 'export-logs';

    let queryPayload = {
      page: payload?.page ? payload.page : DEFAULT_PAGINATION.page,
      pageSize: payload?.pageSize ? payload.pageSize : DEFAULT_PAGINATION.pageSize,
    };

    const response = await request.get(url, queryPayload);
    if (response.status === 200) {
      const combinedData = response.data.data.rows.map((exportLog) => ({
        ...exportLog,
        createdAt: dateFormat(exportLog.createdAt),
      }));
      const exportLogs = {
        rows: combinedData,
        count: response.data.data.count,
        totalRecordsInDB: response.data.data.totalRecordsInDB,
        to: response.data.data.to,
        from: response.data.data.from,
        currentPage: response.data.data.currentPage,
        lastPage: response.data.data.lastPage,
        perPage: response.data.data.perPage,
      };
      dispatch({ type: SET_EXPORT_LOGS_DATA, payload: exportLogs });
    }

    return response;
  } catch (error) {
    return error;
  } finally {
    dispatch({ type: SET_EXPORT_LOGS_LOADER, payload: false });
  }
};

export { fetchExportLogs };
